import React from 'react'
import HeaderOne from "../components/header/HeaderOne";
import BannerOne from "../components/banner/BannerOne";
import AboutOne from "../components/about/AboutOne";
import ServiceOne from "../components/service/ServiceOne";
import Counterup from "../components/counterup/Counterup";
import GalleryOne from "../components/gallery/GalleryOne";
import BrandOne from "../components/brand/BrandOne";
import ContactForm from "../components/contactform/ContactForm";
import MapOne from "../components/map/MapOne";



import FooterOne from "../components/footer/FooterOne";

function HomeOne() {
  return (
    <div>

      <HeaderOne />
      <BannerOne />
      <AboutOne />
      <ServiceOne />
      <Counterup />

      <GalleryOne />
      <BrandOne />
      <ContactForm />
      <FooterOne />

    </div>
  )
}

export default HomeOne